<template>
  <div class="flex flex-col rounded-lg shadow-lg overflow-hidden">
    <a :href="offer.link" class="plain">
      <div class="flex-shrink-0 relative">
        <img class="h-48 w-full object-cover" :src="offer.image_1_url" alt="" />
        <div
          class="bg-yellow-500 absolute top-4 left-0 text-white py-1 px-2 text-xs"
          v-if="isFeatured"
        >
          {{ lang.offer.featured }}
        </div>
        <offer-grid-item-favorite
          :offer="offer"
          v-model:favorite="isFavoriteState"
          :guest="guest"
          @show-register-modal="$emit('show-register-modal', 'favorites')"
          class="absolute top-2 right-3"
        ></offer-grid-item-favorite>
      </div>
      <div
        class="flex-1 p-4 flex flex-col justify-between"
        :class="{
          'bg-white': !isFeatured,
          'bg-primary-800': isFeatured,
        }"
      >
        <div class="flex-1">
          <p
            class="text-sm font-medium mb-0"
            :class="{
              'text-primary-800': !isFeatured,
              'text-white': isFeatured,
            }"
          >
            {{ offer.manufacturer }}
          </p>
          <div class="block mt-0">
            <p
              class="text-lg font-medium truncate mb-0"
              :class="{
                'text-gray-900': !isFeatured,
                'text-white': isFeatured,
              }"
              :title="offer.headlineFull"
            >
              {{ offer.headline }}
            </p>
          </div>
        </div>
        <div class="mt-2 flex justify-between">
          <p
            class="text-sm font-semibold mb-0"
            :class="{ 'text-gray-900': !isFeatured, 'text-white': isFeatured }"
          >
            € {{ offer.priceDisplay }},-
          </p>
          <div
            class="flex space-x-1 text-sm"
            :class="{ 'text-gray-500': !isFeatured, 'text-white': isFeatured }"
          >
            <span class="discount" v-if="showDiscount"
              >{{ offer.discount }}% {{ lang.labels.discount }}</span
            >
          </div>
        </div>
      </div>
    </a>
  </div>
</template>

<script setup>
import { ref, computed } from "vue";
import OfferGridItemFavorite from "./OfferGridItemFavorite.vue";

const props = defineProps({
  guest: Boolean,
  lang: Object,
  offer: Object,
});

const emit = defineEmits(["show-register-modal"]);

// COMPONENT DATA
const isFavoriteState = ref(props.offer.favorite);

// COMPUTED
/**
 * determin if discount should be displayed
 * @return bool
 */
const showDiscount = computed(() => {
  return (
    props.offer.discount !== undefined &&
    props.offer.discount !== "" &&
    props.offer.discount > 0
  );
});

/**
 * determine if offer is featured
 */
const isFeatured = computed(() => {
  return props.offer.featured;
});
</script>
